// extracted by mini-css-extract-plugin
module.exports = {"userManagementListPagination":"userManagementListPagination_3DUFw","width-100":"width-100_1FHbE"};